import * as yup from 'yup'

export const schemaPasswordChange = yup.object().shape({
  password: yup
    .string()
    .required()
    .min(6),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'As senhas não são iguais')
    .required()
    .min(6),
})

export default schemaPasswordChange
